import { config, labels } from "./config.js";

export function initPreferences() {
	const language = document.querySelector("[data-auth-language]");
	const languageToggle = language?.querySelector("[data-auth-language-toggle]");
	const languageMenu = language?.querySelector("[data-auth-language-menu]");
	const languageOptions = [...(language?.querySelectorAll("[data-auth-language-option]") || [])];
	const themeToggle = document.querySelector("[data-auth-theme-toggle]");

	function setLanguageMenuOpen(open) {
		if (!languageToggle || !languageMenu) return;
		languageToggle.setAttribute("aria-expanded", String(open));
		languageMenu.hidden = !open;
	}

	function selectLanguage(languageCode) {
		const allowed = languageOptions.some(
			(option) => option.dataset.authLanguageOption === languageCode,
		);
		if (!allowed) return;
		setLanguageMenuOpen(false);
		languageToggle?.focus({ preventScroll: true });
		if (languageCode === config.currentLanguage) return;
		const secure = location.protocol === "https:" ? "; Secure" : "";
		document.cookie = `preferred_language=${encodeURIComponent(
			languageCode,
		)}; Path=/; Max-Age=31536000; SameSite=Lax${secure}`;
		location.reload();
	}

	languageToggle?.addEventListener("click", () => {
		setLanguageMenuOpen(languageToggle.getAttribute("aria-expanded") !== "true");
	});
	languageOptions.forEach((option) => {
		option.addEventListener("click", () => selectLanguage(option.dataset.authLanguageOption));
	});
	document.addEventListener("click", (event) => {
		if (!language?.contains(event.target)) setLanguageMenuOpen(false);
	});
	document.addEventListener("keydown", (event) => {
		if (event.key !== "Escape" || languageToggle?.getAttribute("aria-expanded") !== "true")
			return;
		setLanguageMenuOpen(false);
		languageToggle.blur();
	});

	function refreshThemeToggle() {
		if (!themeToggle || !window.syscofyAuthTheme) return;
		const dark = window.syscofyAuthTheme.getMode() === "dark";
		const label = dark ? labels.switchLight : labels.switchDark;
		themeToggle.setAttribute("aria-label", label);
		themeToggle.setAttribute("title", label);
		themeToggle.setAttribute("aria-pressed", String(dark));
	}
	themeToggle?.addEventListener("click", () => {
		const theme = window.syscofyAuthTheme;
		if (!theme) return;
		theme.setMode(theme.getMode() === "dark" ? "light" : "dark");
		refreshThemeToggle();
	});
	refreshThemeToggle();
}
